'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

var _scrollLock = require('scroll-lock');

var _scrollLock2 = _interopRequireDefault(_scrollLock);

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

var _themeCart = require('@shopify/theme-cart');

var _process = require('../sections/process');

var _process2 = _interopRequireDefault(_process);

var _shopWallpaper = require('../sections/shop-wallpaper');

var _shopWallpaper2 = _interopRequireDefault(_shopWallpaper);

var _mobilenav = require('../sections/mobilenav');

var _mobilenav2 = _interopRequireDefault(_mobilenav);

var _cart = require('./cart');

var _cart2 = _interopRequireDefault(_cart);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('./jquery.parallax.min.js');

var _imagesloaded = require('imagesloaded');

var _imagesloaded2 = _interopRequireDefault(_imagesloaded);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_imagesloaded2.default.makeJQueryPlugin(_jquery2.default);

(0, _jquery2.default)('.footerspacer').css('height', (0, _jquery2.default)('footer').outerHeight() + 'px');

// Qty update
(0, _jquery2.default)('.qty input').on('input', function () {
  (0, _jquery2.default)('.qty input').trigger('click');
  return false;
});
(0, _jquery2.default)('.qty .minus, .qty .plus').on('click', function () {
  setTimeout(function () {
    (0, _jquery2.default)('input[name="update"]').trigger('click');
  }, 150);
  return false;
});

// Images Fade In
(0, _jquery2.default)('#MainContent').imagesLoaded().progress(function (instance, image) {
  (0, _jquery2.default)(image.img).addClass('in');
});

// Product Lightbox
(0, _jquery2.default)('[data-toggle="product-lightbox"]').on('click', function () {
  (0, _jquery2.default)('body').addClass('product-lightbox-visible');
  _scrollLock2.default.disablePageScroll();

  return false;
});
(0, _jquery2.default)('[data-dismiss="product-lightbox"]').on('click', function () {
  (0, _jquery2.default)('body').removeClass('product-lightbox-visible');
  _scrollLock2.default.enablePageScroll();

  return false;
});

// Sidebar Filters
(0, _jquery2.default)('.sidebar-filter-toggle').on('click', function () {
  var $filters = (0, _jquery2.default)(this).next('.sidebar-filter');
  toggleFilters($filters);

  return false;
});
(0, _jquery2.default)('.sidebar-filter-close').on('click', function () {
  var $filters = (0, _jquery2.default)(this).parents('.sidebar-filter');
  toggleFilters($filters);

  return false;
});

function toggleFilters($filters) {
  if ($filters.hasClass('visible')) {
    $filters.removeClass('visible');
    _scrollLock2.default.enablePageScroll();
  } else {
    $filters.addClass('visible');
    _scrollLock2.default.disablePageScroll();
  }
}

(0, _jquery2.default)('.my-parallax-window').parallax({
  speed: -0.2,
  sliderSelector: '>.my-parallax-slider',
  mirrorSelector: '.parallax-mirror',
  zIndex: 10,
  excludeAgents: false
});

_process2.default.init();
_shopWallpaper2.default.init();
_mobilenav2.default.init();
_cart2.default.init();

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
if ((0, _themeCart.cookiesEnabled)()) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}

(0, _jquery2.default)(function () {
  // caches a jQuery object containing the header element
  /*
        var header = $("#shopify-section-header");
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
             if (scroll >= 100) {
                header.addClass("small");
            } else {
                header.removeClass('small');
            }
        });
     */

  (0, _jquery2.default)('a[href^="#"]').click(function (e) {
    console.log('animate');
    e.preventDefault();
    e.stopPropagation();
    var el = (0, _jquery2.default)((0, _jquery2.default)(this).attr('scrollto')).offset().top - 150;
    (0, _jquery2.default)('html, body').animate({
      scrollTop: el
    }, 500);

    return false;
  });
});